<template>
  <header class="navbar navbar-light navbar-static-top bd-navbar">
    <alert v-model="showAlert" :duration="2000" :type="alert.type" placement="top-right">
      {{ alert.msg }}
    </alert>
    <div class="container-fluid">
      <nav>
        <div class="navbar-toggleable-xs">
          <a class="navbar-brand" href="/">
            <h2 class="header"><i class="fa fa-magic" style="color: #0275d8;"></i> Icon Generator</h2>
          </a>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import easele from './../easele'
import settings from './../settings'
import UserService from '../tools/UserService'
import IconService from '../tools/IconService'
import IconTile from './IconTile'
import {alert, modal} from 'vue-strap'

const MAX_ICON_SIZE_IN_MODAL_VIEW = 128
const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/


export default {
  data() {
    return {
      model: easele.model,
      alert: {},
      formLoading: false,
      errors: {},
      iconsLoaded: false,
      loginModalIsVisible: false,
      savedIconModalIsVisible: false,
      email: "",
      password: "",
      password_confirmation: "",
      full_name: "",
      aboutModal: false,
      modals: {
        logIn: false,
        signUp: false
      },
      iconService: new IconService(),
      userService: new UserService()
    }
  },
  computed: {
    showAlert() {
      return !!this.alert.msg
    },
    loggedIn() {
      return false
      // let user = easele &&
      //   easele.model &&
      //   easele.model.user;
      // if (user) {
      //   // Change placement of this block (?)
      //   this.loginModalIsVisible = false
      // }
      // else if( easele.utils.getCookie("easele_auth_token") ) {
      //   this.userService.current( easele.utils.getCookie("easele_auth_token") )
      // }
      // return user && user.auth_token
    }
  },
  components: {
    IconTile,
    modal,
    alert
  },
  methods: {
    getSvgObjectWithName(name) {
      let obj
      this.model.iconList.some((el) => {
        if (el.name === name) {
          obj = el;
          return true
        }
      })
      return obj
    },

    getWidth(iconObj) {
      let width = iconObj.size + iconObj.margin
      if (width > MAX_ICON_SIZE_IN_MODAL_VIEW) {
        width = MAX_ICON_SIZE_IN_MODAL_VIEW
      }
      return width
    },

    selectSavedIcon(icon) {
      this.$events.emit('selectSavedIcon', icon)
      this.savedIconModalIsVisible = false
    },

    openSavedIcons() {
      if (!this.loggedIn) {
        this.showModal('logIn');
        return;
      }
      this.savedIconModalIsVisible = true
      if (!this.iconsLoaded) {
        this.iconService.list()
            .then((data) => {
              if (Array.isArray(data)) {
                this.model.savedIcons = data
                this.iconsLoaded = true
              }
            })
      }
    },

    saveIcon() {

      if (!this.loggedIn) {
        this.showModal('signUp');
        return;
      }

      let that = this
      this.iconService.save(this.model.currentIcon)
          .then((iconObj) => {
            that.alert = {
              msg: 'Icon saved',
              type: 'success'
            }
            setTimeout(() => that.alert = {}, 2500)
          })
          .catch((errText) => {
            that.alert = {
              msg: errText,
              type: 'danger'
            }
            setTimeout(() => that.alert = {}, 2500)
          })
    },

    checkValidationAndSetError(fieldNames, e) {

      let validated = true
      if (typeof fieldNames === 'string') {
        fieldNames = [fieldNames]
      }
      let errors = Object.assign({}, this.errors)

      fieldNames.forEach((el) => {

        if (settings.VALIDATION_RULES[el].required && !this[el]) {
          validated = false
          errors[el] = settings.VALIDATION_RULES[el].required
        } else if (settings.VALIDATION_RULES[el].email && !EMAIL_REGEXP.test(this[el])) {
          validated = false
          errors[el] = settings.VALIDATION_RULES[el].email
        } else if (settings.VALIDATION_RULES[el].match && this[el] !== this.password) {
          validated = false
          errors[el] = settings.VALIDATION_RULES[el].match
        } else if (settings.VALIDATION_RULES[el].short && this[el].length < settings.MIN_PASSWORD_LENGTH) {
          validated = false
          errors[el] = settings.VALIDATION_RULES[el].short
        }
      })

      this.errors = errors
      return validated
    },

    validated(formType) {
      let validated = true
      if (formType === 'signUp') {
        validated = this.checkValidationAndSetError(['full_name', 'email', 'password', 'password_confirmation'])
      } else if (formType === 'logIn') {
        validated = this.checkValidationAndSetError(['email', 'password'])
      }
      return validated
    },

    logOut() {
      this.email = ''
      this.password = ''
      this.password_confirmation = ''
      this.full_name = ''
      this.modals.logIn = true
      this.savedIcons = []
      this.iconsLoaded = false
      this.userService.logout();
      easele.utils.removeAuthCookie();
    },

    handleErrorsFromServer(errorsFromObj) {
      let obj = {}
      for (let errorType in errorsFromObj) {
        if (errorsFromObj.hasOwnProperty(errorType)) {
          obj[errorType] = errorsFromObj[errorType].join(', ')
        }
      }
      return obj;
    },

    logIn() {
      let that = this
      if (this.validated('logIn')) {
        that.formLoading = true
        this.userService.login(this.email, this.password)
            .then(() => {
              that.formLoading = false
            })
            .catch(errorObj => {
              that.formLoading = false
              if (errorObj.errors) {
                that.errors = this.handleErrorsFromServer(errorObj.errors)
              } else if (errorObj.error) {
                let errors = Object.assign({}, this.errors)
                errors.other = errorObj.error
                this.errors = errors
              }

            })
      }
    },

    signUp() {
      let that = this
      if (this.validated('signUp')) {
        that.formLoading = true
        this.userService.signup(this.full_name, this.email, this.password, this.password_confirmation)
            .then(() => {
              that.formLoading = false
            })
            .catch(errorObj => {
              that.formLoading = false
              if (errorObj.errors) {
                this.errors = this.handleErrorsFromServer(errorObj.errors)

              } else if (errorObj.error) {
                let errors = Object.assign({}, this.errors)
                errors.other = errorObj.error
                this.errors = errors
              }
            })
      }
    },

    showModal(type, e) {
      if (e) {
        e.preventDefault()
      }

      this.loginModalIsVisible = true
      for (let modal in this.modals) {
        if (this.modals.hasOwnProperty(modal)) {
          if (modal === type) {
            this.modals[modal] = true
          } else {
            this.modals[modal] = false
          }
        }
      }
      this.modals[type] = true
    }
  }
}

</script>
<style scoped lang="scss">
.header {
  color: #ffffff;
}

.disabled {
  input,
  button {
    pointer-events: none;
    cursor: not-allowed;
    opacity: .65;
  }
}

.fb-auth a {
  color: white;
}

.fb-auth a:hover {
  color: #0064FF;
}

nav a:active,
nav a:focus {
  text-decoration: none
}

nav a:hover {
  text-decoration: none;
  border-bottom: 1px solid #014c8c
}

a.navbar-brand:hover {
  border: none
}

.logout-link {
  margin-left: 10px
}

.welcome {
  float: right;
  padding: 15px 0 15px 15px;
}

.error-msg {
  font-size: 0.8em;
  margin: 0;
  color: red
}

.saved-icon-wrapper {
  text-align: center
}

.saved-icon-list {
  margin: 0;
  padding: 0;
}

.saved-icon {
  margin: 5px;
  text-align: left;
  display: inline-block;

  .icon-with-margin {
    display: inline-block
  }

  .icon-wrapper {
    width: 128px;
    height: 128px;
  }

}

.navbar-nav {
  float: left
}

.navbar-right {
  float: right;
}

.navbar-nav > li {
  display: inline-block;
  padding: 15px 0 15px 15px;
}

.fb-btn {
  margin-bottom: 15px;
}

.sign-up,
.log-in {
  .left-col {
    @media (min-width: 576px) {
      border-right: 1px solid #ccc;
      padding-right: 15px;
    }

    input {
      text-align: left;
    }
  }
}

.modal-footer {
  text-align: center;

  ul {
    padding-left: 0;
    text-align: center;
    list-style: none;

    li {
      padding: 5px;
      display: inline-block;
    }
  }
}

.form-control-danger {
  border-color: #d9534f;
}

.modal-title {
  text-align: center;

  .fa {
    margin-right: .5em;
    color: #0064FF;
  }
}

</style>
